var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnArrowNarrowShortDown = function SvgIcnArrowNarrowShortDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7068 10.293C14.8946 10.4805 15 10.7348 15 11C15 11.2652 14.8946 11.5195 14.7068 11.707L10.7018 15.707C10.5141 15.8945 10.2595 15.9998 9.99395 15.9998C9.72846 15.9998 9.47383 15.8945 9.28607 15.707L5.28106 11.707C5.09868 11.5184 4.99776 11.2658 5.00004 11.0036C5.00232 10.7414 5.10762 10.4906 5.29326 10.3052C5.4789 10.1198 5.73003 10.0146 5.99255 10.0123C6.25508 10.01 6.50799 10.1108 6.69683 10.293L8.9927 12.586V5C8.9927 4.73478 9.09819 4.48043 9.28596 4.29289C9.47373 4.10536 9.72841 4 9.99395 4C10.2595 4 10.5142 4.10536 10.7019 4.29289C10.8897 4.48043 10.9952 4.73478 10.9952 5V12.586L13.2911 10.293C13.4788 10.1055 13.7335 10.0002 13.999 10.0002C14.2645 10.0002 14.5191 10.1055 14.7068 10.293Z",
    fill: "#FF5B56"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnArrowNarrowShortDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_arrow_narrow_short_down.bda9e52e.svg";
export { ForwardRef as ReactComponent };